import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import MenuCTA from "@/components/MenuCTA";
import MenuPage from "@/pages/MenuPage";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import OrderSection from "@/components/OrderSection";
import Footer from "@/components/Footer";
import OwnerDashboard from "@/components/OwnerDashboard";
import PaymentResult from "@/components/PaymentResult";
import OrderHubPage from "@/pages/OrderHubPage";
import CategoryPage from "@/pages/CategoryPage";
import CartPage from "@/pages/CartPage";
import { CartProvider } from "@/cart/CartContext";
import { Toaster } from "@/components/ui/sonner";

function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <MenuCTA />
        <Manifesto />
        <Gallery />
        <OrderSection />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="bg-coal-900 text-ink min-h-screen overflow-x-clip" data-testid="app-root">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <CartProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/order" element={<OrderHubPage />} />
            <Route path="/order/c/:slug" element={<CategoryPage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/owner" element={<OwnerDashboard />} />
            <Route path="/payment/success" element={<PaymentResult variant="success" />} />
            <Route path="/payment/cancel" element={<PaymentResult variant="cancel" />} />
          </Routes>
        </CartProvider>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}
